import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Box,
  IconButton,
  Divider,
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import CloseIcon from "@mui/icons-material/Close";
import { direction } from "html2canvas/dist/types/css/property-descriptors/direction";

interface ConfirmDialogProps {
  open: boolean;
  title?: string;
  message: React.ReactNode | string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title,
  message,
  confirmText,
  cancelText,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: "6px",
          width: "420px",
        },
      }}
    >
      {/* Header */}
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        py={1}
      >
        <Typography fontSize="14px" fontWeight={600}>
          {title}
        </Typography>

        <IconButton size="small" onClick={onClose}>
          <CloseIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>
      <Divider />
      {/* Content */}
      <DialogContent
        sx={{ display: "flex", gap: 2, py: 3, flexDirection: "column" }}
      >
        {/* Icon */}
        <Box
          sx={{
            minWidth: 36,
            height: 54,
            width: 54,
            borderRadius: "50%",
            background: "#FFAA01",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <WarningAmberRoundedIcon sx={{ color: "#fff", fontSize: 22 }} />
        </Box>

        {/* Message */}
        <Typography fontSize="14px" fontWeight={600} color="#323232">
          {message}
        </Typography>
      </DialogContent>
      {/* Actions */}
      <Box
        display="flex"
        justifyContent="center"
        gap={2}
        pb={3}
        width="100%"
        maxWidth={380}
        margin="0 auto"
      >
        {cancelText && (
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              borderRadius: "24px",
              px: 4,
              fontSize: "12px",
              textTransform: "none",
              borderColor: "#dcdcdc",
              color: "#4b4b4b",
              flex: confirmText ? 1 : undefined,
              width: confirmText ? "100%" : "100%",
            }}
          >
            {cancelText}
          </Button>
        )}

        {confirmText && (
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{
              borderRadius: "24px",
              fontSize: "12px",
              px: 4,
              py: 1,
              textTransform: "none",
              whiteSpace: "nowrap",
              background: "#3a1673",
              "&:hover": {
                background: "#3a1673",
              },
              flex: cancelText ? 1 : undefined,
              width: cancelText ? "100%" : "100%",
            }}
          >
            {confirmText}
          </Button>
        )}
      </Box>
    </Dialog>
  );
};

export default ConfirmDialog;
